exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_checkboxSkeletonWrapper_39x1B1Yg4Xz95ipbo41Xvp {\n  display: flex;\n  margin-top: 10px;\n  width: 100%;\n}\n\n.IA_checkboxWrapper_3QoKmQUmfCt2Gy-Cld0WnM {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_checkboxSkeletonWrapper": "IA_checkboxSkeletonWrapper_39x1B1Yg4Xz95ipbo41Xvp",
	"IA_checkboxWrapper": "IA_checkboxWrapper_3QoKmQUmfCt2Gy-Cld0WnM"
};